import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
html {
  font-size: var(--dynamic-font-size, 10px);
}

* {
  margin: 0;
  padding: 0;
  font-variant-numeric: lining-nums;
  /* font-size: var(--dynamic-font-size, 10px);  */


  /* @media screen and (min-width: 5120px) { 
    font-size: 56px;
  }

  @media screen and (min-width: 3840px) and (max-width: 5119px){ 
    font-size: 42px;
  }
  @media screen and (min-width: 3200px) and (max-width: 3839px) {
    font-size: 35px;
  }

  @media screen and (min-width: 2560px) and (max-width: 3199px) { 
    font-size: 28px;
  }

  @media screen and (min-width: 2048px) and (max-width: 2559px) { 
    font-size: 22.4px;
  }

  @media screen and (min-width: 1920px) and (max-width: 2047px) { 
    font-size: 21px;
  }

  @media screen and (min-width: 1600px) and (max-width: 1919px) { 
    font-size: 17.5px;
  }  

  @media screen and (min-width: 1280px) and (max-width: 1599px) { 
    font-size: 14px;
  }

  @media screen and (min-width: 960px) and (max-width: 1279px) {
    font-size: 12px;
  }  

  @media screen and (min-width: 854px) and (max-width: 959px) { /
    font-size: 10px;
  }

  @media screen and (min-width: 640px) and (max-width: 853px) {  
    font-size: 8px;
  }

  @media screen and (min-width: 423px) and (max-width: 639px) {  
    font-size: 5px;
  }

  @media screen and (min-width: 257px) and (max-width: 422px) { /
    font-size: 4px;
  }

  @media screen and (max-width: 256px) { 
    font-size: 3px;
  } */
}

body {
  width: 100vw;
  font-family: 'Cormorant Garamond', sans-serif;
  /* font-family: "Open Sans", sans-serif; */
  font-optical-sizing: auto;
  /*font-weight: 300;*/
  font-style: normal;
  overflow-x: hidden;
}

a {
  text-decoration: none;
  color: inherit;

  &:visited,
  &:active {
    text-decoration: none;
    color: inherit;
  }
}

::-webkit-scrollbar {
    width: 0.625rem;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background: #dedede;
    border-radius: 0.3125rem;
}

::-webkit-scrollbar-thumb:hover {
    background: #b9b9b9;
}
`;

// body {
//     background: #faf8f5;
//     font-family: 'Montserrat', sans-serif;
//     width: 100vw;
//     overflow-x: hidden;
//   }
